import React, { useEffect, useState } from "react";

import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import classnames from "classnames";

import { DefaultTooltip } from "../Tooltip";

type Props = {
  value?: string;
  backgroundColor?: string;
  textColor?: string;
  align?: string;
  classes?: any;
  height?: number | string;
  marginBottom?: number | string;
};

const styles = () => ({
  customBadge: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
      props?.backgroundColor,
    minWidth: "51px",
    padding: "6px 16px",
    height: (props: Props) => (props?.height != null ? props.height : "40px"),
    borderRadius: "20px",
    maxWidth: "148px",
    cursor: "default",
    width: "fit-content",
    marginBottom: (props: Props) => props.marginBottom ?? undefined,
  },
  textValue: {
    color: (props: { textColor?: string }) => props?.textColor,
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: "20px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    minWidth: "51px",
    maxWidth: "148px",
    width: "fit-content",
  },
});

const badgeTextCSS = makeStyles(() => ({
  badgeAlign: {
    textAlign: "center",
    display: "block",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "148px",
    width: "fit-content",
  },
}));

const SimpleBadge = (props: Props) => {
  const { classes, value } = props;
  const clasz = badgeTextCSS();
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

  useEffect(() => {
    if (value) {
      const hasEllipsis = value.length > 20;

      setIsTooltipVisible(hasEllipsis);
    }
  }, []);

  return (
    <div className={classnames(clasz.badgeAlign, classes.customBadge)}>
      {isTooltipVisible ? (
        <DefaultTooltip title={value || ""} placement="top-start">
          <span className={classnames(clasz.badgeAlign, classes.textValue)}>{value}</span>
        </DefaultTooltip>
      ) : (
        <span className={classes.textValue}>{value}</span>
      )}
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

const BadgeType = (props: Props) => {
  const { value, classes, height, marginBottom } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          classes={classes}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          height={height}
          marginBottom={marginBottom}
        />
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case "import":
      return renderBadge("#e7effd", "#5D92F4", value);
    case "export":
      return renderBadge("#fdf0e7", "#F18E47", value);
    case "storage":
      return renderBadge("#d1d4e0", "#464D69", value);
    case "toll":
      return renderBadge("#e7effd", "#5D92F4", value);
    case "fine art":
      return renderBadge("#fff9e6", "#ffc000", value);
    case "business service":
      return renderBadge("#ffe6f2", "#FF69B4", value);
    case "interstate jobs":
      return renderBadge("#d1d4e0", "#464D69", value);
    case "interstate":
      return renderBadge("#d1d4e0", "#464D69", value);
    case "local":
      return renderBadge("#e8e7fd", "#8683F6", value);
    case "country removal":
      return renderBadge("#e6ffe8", "#00D014", value);
    case "long distance":
      return renderBadge("#cccccc", "#727272", value);
    case "store out":
      return renderBadge("#d1d4e0", "#464D69", value);
    default:
      return renderBadge("#d1d4e0", "#464D69", value);
  }
};

export default BadgeType;
